import environmentConfig from './utils/configs';

const appVersion = import.meta.env.VITE_SENTRY_RELEASE || '0.0.0';

// must match TourDurationMinutes in API appsettings
export const TOUR_DURATION_MINUTES = environmentConfig.tourDurationMinutes ?? 60;
export const SMS_TEMPLATE_MAX_LENGTH = 160;

const config = {
    EVENT_NAMESPACE: 'beststart-pathway-web',
    audience: 'beststart-pathway-web',
    gitBranch: null,
    version: appVersion,
    namespace: 'beststart-pathway-web',
    tag: 'beststart-pathway-web',
    env: import.meta.env.MODE,
    pathwayApiUrl: environmentConfig.pathwayApiUrl,
    LogLevel: environmentConfig.LogLevel || 0,
    sampleRate: environmentConfig.sampleRate || 0,
    sentry: environmentConfig.sentry || null,
    presence: {
        heartbeatMs: environmentConfig.presenceHeartbeatMs ?? 15000,
        snapshotRefreshMs: environmentConfig.presenceSnapshotRefreshMs ?? 60000,
        awayGraceMs: environmentConfig.presenceAwayGraceMs ?? 300000,
    },
    authentication: {
        clientId: environmentConfig.clientId,
        authority: environmentConfig.authority,
        authBaseUrl: environmentConfig.pathwayApiUrl,
        redirectUri: window.location.hostname === "localhost.lambdatest.com"
            ? 'https://localhost.lambdatest.com:50329/login'
            : `${window.location.origin}/login`,
    },
};

if (config.authentication.clientId?.startsWith('REPLACE_WITH_')) {
    console.error('[config] Production clientId has not been set — authentication will fail.');
}

export default config;
